import React from 'react';
// import { ILoadDataError } from '../hooks/useLoadData';
// import styles from './LoadingError.scss';

interface IJsonApiDataError {
    statusCode: number;
    responseData: {
        errors: Array<{
            title: string;
            detail: string;
            status: string;
        }>;
    };
}

export interface ILoadingErrorProps {
    className?: string;
    error: IJsonApiDataError;
    /**
     * Fallback text to display if no error message is found.
     */
    text?: string;
}

export const errorMessages = {
    400: 'Fehlerhafter Request.',
    401: 'Nicht eingeloggt.',
    403: 'Keine Berechtigung.',
    404: 'Endpunkt nicht gefunden.',
    405: 'Methode nicht erlaubt.',
    408: 'Server Timeout.',
    409: 'Daten unvollständig oder ungültig.',
    413: 'Datei zu groß.',
    415: 'Falscher Dateityp.',
    500: 'Server Error.',
};

const JsonApiError: React.FC<React.PropsWithChildren<ILoadingErrorProps>> = ({ error, text, className = '' }) => {
    return (
        <>
            {error?.responseData?.errors ? (
                error.responseData.errors?.map((e, idx) => {
                    return (
                        <div key={idx}>
                            Fehler {e.status}: {e.title}
                            <br /> {e.detail}
                        </div>
                    );
                })
            ) : (
                <div>
                    {text || 'Fehler'} {error.statusCode}: {errorMessages[error.statusCode]}
                </div>
            )}
        </>
    );
};

export default JsonApiError;
